import { StyleSheet } from 'aphrodite';
import { background, borderColor, grayDark, titles, white, brandPrimaryLight } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		marginBottom: 24,
	},

	header: {
		fontSize: 16,
		fontWeight: 600,
		color: titles,
		marginBottom: 16,
	},

	// Category level styles (outermost level)
	categorySection: {
		marginBottom: 8,
		border: `1px solid ${borderColor}`,
		borderRadius: 8,
		overflow: 'hidden',
	},

	categoryHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '12px 16px',
		backgroundColor: '#f5f7fa',
		cursor: 'pointer',
		transition: 'background-color 0.2s',
		':hover': {
			backgroundColor: '#eef1f5',
		},
	},

	categoryHeaderExpanded: {
		backgroundColor: '#eef1f5',
	},

	categoryTitle: {
		margin: 0,
		fontSize: 15,
		fontWeight: 600,
		color: titles,
	},

	categoryContent: {
		paddingLeft: 16,
		paddingBottom: 8,
	},

	// Skill area level styles (nested within categories)
	skillAreaSection: {
		marginTop: 8,
		marginRight: 8,
		border: `1px solid ${borderColor}`,
		borderRadius: 6,
		overflow: 'hidden',
	},

	skillAreaHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '10px 14px',
		backgroundColor: white,
		cursor: 'pointer',
		transition: 'background-color 0.2s',
		':hover': {
			backgroundColor: '#fafbfc',
		},
	},

	skillAreaHeaderExpanded: {
		backgroundColor: '#fafbfc',
		borderBottom: `1px solid ${borderColor}`,
	},

	skillAreaTitle: {
		margin: 0,
		fontSize: 14,
		fontWeight: 500,
		color: titles,
	},

	// Chevron styles for expand/collapse arrows
	chevron: {
		width: 16,
		height: 16,
		transition: 'transform 0.2s',
		flexShrink: 0,
		color: grayDark,
	},

	chevronExpanded: {
		transform: 'rotate(90deg)',
	},

	scenarioList: {
		border: `1px solid ${borderColor}`,
		borderTop: 'none',
		borderBottomLeftRadius: 4,
		borderBottomRightRadius: 4,
	},

	scenarioItem: {
		display: 'flex',
		alignItems: 'center',
		padding: 12,
		cursor: 'pointer',
		borderBottom: `1px solid ${borderColor}`,
		transition: 'background-color 0.2s',
		':last-child': {
			borderBottom: 'none',
		},
		':hover': {
			backgroundColor: background,
		},
	},

	scenarioItemSelected: {
		backgroundColor: `${brandPrimaryLight}22`,
		':hover': {
			backgroundColor: `${brandPrimaryLight}33`,
		},
	},

	scenarioContent: {
		flex: 1,
		minWidth: 0,
	},

	scenarioName: {
		fontSize: 14,
		fontWeight: 500,
		color: titles,
		marginBottom: 4,
	},

	scenarioDescription: {
		fontSize: 12,
		color: grayDark,
		marginBottom: 0,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},

	loadingState: {
		padding: 24,
		textAlign: 'center',
		color: grayDark,
		fontSize: 14,
	},

	emptyState: {
		padding: 24,
		textAlign: 'center',
		color: grayDark,
		fontSize: 14,
		border: `1px solid ${borderColor}`,
		borderRadius: 4,
		backgroundColor: background,
	},
});
